const KEY = 'tts.ubuntuSignalScores.v1';
let listeners = new Set();

function load(){
  try { const data = JSON.parse(localStorage.getItem(KEY)||'{}'); return data && typeof data==='object' ? data : {}; } catch { return {}; }
}
function save(scores){ localStorage.setItem(KEY, JSON.stringify(scores)); listeners.forEach(l=> l(scores)); }

export function getScores(){ return load(); }
export function setScore(id, value){
  const allowed = ['go','no-go','cautious', null];
  if(!allowed.includes(value)) return;
  const current = load();
  const next = { ...current, [id]: value };
  save(next);
}
export function resetScores(){ save({}); }
export function subscribe(fn){ listeners.add(fn); fn(load()); return ()=> listeners.delete(fn); }

export function computeOverall(scores){
  const values = Object.values(scores||{}).filter(Boolean);
  if(values.includes('no-go')) return 'no-go';
  if(values.includes('cautious')) return 'cautious';
  if(values.length === 0) return null;
  return 'go';
}
